<template>
  <div
    class="min-h-0 min-w-44 flex flex-col gap-0.5 overflow-y-auto overflow-x-hidden rounded-md border border-gray-300 background-default p-1 shadow-default dark:border-gray-700"
  >
    <slot />
  </div>
</template>
